export default "__VITE_ASSET__i2idHLwm__"